export default "__VITE_ASSET__DU2NPC_c__"